module.exports = __webpack_public_path__ + "img/gryllotalpa-orientalis.e1e3b072.jpg";